import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { FormulaConfigPage } from "@/features/onboarding/pages/formula-config-page";

export const Route = createFileRoute("/onboarding/_guarded/formula-config")({
	head: () => pageTitle("Formula"),
	component: FormulaConfigPage,
});
